import {
    Button,
    Grid,
    Typography,
  } from "@mui/material";
  
  import { Fragment } from "react";
  import { CompanyPartHeader } from "../../../../components/PartHeader";
  
  export const SubTitle = ({ screenMode, onClickSave, onClickReturn }) => {
    const pageTitle = screenMode === 1 ? "ユーザー情報登録" : "ユーザー情報編集";
    const saveButton = screenMode === 1 ? "登録" : "更新";

    return (
      <Fragment>
        <CompanyPartHeader>
        <Grid container spacing={1}>
          <Grid item xs>
            <Typography fontWeight="bold" fontSize={20}>
              {pageTitle}
            </Typography>
          </Grid>
          <Grid item xs="auto">
            <Button variant="contained" onClick={onClickSave}>
              {saveButton}
            </Button>
          </Grid>
          <Grid item xs="auto">
            <Button variant="outlined" onClick={onClickReturn}>
              戻る
            </Button>
          </Grid>
        </Grid>
      </CompanyPartHeader>
      </Fragment>
    );
  };